import React from "react";
import PropTypes from "prop-types";
import cname from "./style.module.scss";
import { PipetteBody } from "./PipetteBody";
import { PipettePlunger } from "./PipettePlunger";
import { useTranslation } from "react-i18next";

export function PipetteImage(props) {
  const { t } = useTranslation();
  return (
    <div className={`${cname.pipette} ${props.className}`}>
      <PipettePlunger
        className={`${cname.plunger} pipette-plunger`}
        type={props.type}
        ariaLabel={t("MicroPipettePlunger.string")}
      />
      <PipetteBody
        className={`${cname.body} pipette-body`}
        type={props.type}
        solution={props.solution}
        hasTip={props.hasTip}
        ariaLabel={t("MicropipetteBody.string")}
      />
    </div>
  );
}

PipetteImage.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * Type of MicroPipette
   */
  type: PipetteBody.propTypes.type,
};

PipetteImage.defaultProps = {
  type: PipetteBody.defaultProps.type,
};
